<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Listado de Conversiones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-6">
              <NuevaConversionModalComponent />
              <a
                v-if="mostrarRefresh"
                class="btn btn-sm btn-info"
                @click="refreshData"
                href="#"
                >Refrescar</a
              >
            </div>
            <div class="col-sm-6">
              <div class="form-inline justify-content-sm-end">
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_tienda"
                  @change="filterData"
                  style="width: 150px"
                >
                  <option value>Tiendas</option>
                  <option
                    v-for="data in tiendas"
                    :value="data.codigo"
                    v-bind:key="data.id"
                  >
                    {{ data.nombre }}
                  </option>
                </select>
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData"
                />
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="table-responsive"
        >
          <!-------------------- Tabla de Resultados -------------------->

          <table
            v-if="dataTabla && dataTabla.results.length > 0"
            id="table"
            class="table table-hover"
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Codigo Producto</th>
                <th>Tienda</th>
                <th>Usuario</th>
                <th>Fecha</th>
                <th>Cantidad</th>
                <th class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="height: 40px"
                v-for="current in dataTabla.results"
                v-bind:key="current.id"
                @click="rowClick(current)"
              >
                <td>{{ current.numero }}</td>
                <td>{{ current.producto }}</td>
                <td>{{ current.tienda.nombre }}</td>
                <td>{{ current.usuario.name }}</td>
                <td>{{ current.fecha }}</td>
                <td>{{ current.cantidad }}</td>
                <td class="text-center">{{ current.estado_str }}</td>
              </tr>
            </tbody>
          </table>
          <PaginationComponent
            :currentPage="currentPage"
            :data="dataTabla"
            @pagechanged="onPageChange"
          />
          <!-------------------- END - Basic Table -------------------->
        </div>
        <br />
        <br />
        <button
          id="btnExport"
          class="btn btn-secondary btn-block btn-sm"
          @click="fnExcelReport()"
        >
          Exportar en CSV
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ConversionesTableComponent from "@/components/inventario/conversiones/ConversionesTableComponent";
import NuevaConversionModalComponent from "@/components/inventario/conversiones/NuevaConversionModalComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    UsuarioEnTablaComponent,
    ConversionesTableComponent,
    NuevaConversionModalComponent,
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      dataTabla: null,
      params: "",
      tiendas: [],
      filtro_tienda: "",
    };
  },
  mounted() {
    let self = this;
    self.filterData();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tiendas = response.data;
      });
    },
    refreshConversiones(params) {
      let self = this;
      DynamicService.fetch("inv", "conversion-e", params).then((response) => {
        self.dataTabla = response.data;
        console.log(response.data);
      });
    },
    filterData() {
      let self = this;
      this.$data.currentPage = 1;
      self.params = {
        tienda: this.filtro_tienda,
        estado: this.filtro_estado,
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        //quitar_paginacion: true,
      };
      self.refreshConversiones(self.params);
    },
    clearFilterData() {
      let self = this;
      this.filtro_tienda = "";
      this.searchtext = "";
      this.currentPage = 1;
      self.params = {
        page: this.currentPage,
        "filter[search]": this.searchtext,
        tienda: this.filtro_tienda,
        estado: this.filtro_estado,
        //quitar_paginacion: true,
      };
      self.refreshConversiones(self.params);
    },
    onPageChange(page) {
      this.currentPage = page;
      DynamicService.fetch("inv", "conversion-e", {
        page: page,
        "filter[search]": this.$data.searchtext,
        tienda: this.filtro_tienda,
        estado: this.filtro_estado,
      }).then((response) => {
        this.dataTabla = response.data;
      });
    },
    rowClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: "inventario-conversiones-editar",
          params: { id: current.id },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "inventario-conversiones-editar",
          params: { id: current.id },
        });
      }
    },
    fnExcelReport() {
      var i, j;
      var csv = "";
      var table = document.getElementById("table");
      var table_headings = table.children[0].children[0].children;
      var table_body_rows = table.children[1].children;
      var heading;
      var headingsArray = [];
      for (i = 0; i < table_headings.length; i++) {
        heading = table_headings[i];
        headingsArray.push('"' + heading.innerHTML + '"');
      }
      csv += headingsArray.join(",") + ";\n";
      var row;
      var columns;
      var column;
      var columnsArray;
      for (i = 0; i < table_body_rows.length; i++) {
        row = table_body_rows[i];
        columns = row.children;
        columnsArray = [];
        for (j = 0; j < columns.length; j++) {
          var column = columns[j];
          columnsArray.push('"' + column.innerHTML + '"');
        }
        csv += columnsArray.join(",") + ";\n";
      }

      this.download("Conversiones.csv", csv);
    },
    download(filename, text) {
      var pom = document.createElement("a");
      pom.setAttribute(
        "href",
        "data:text/csv;charset=utf-8," + encodeURIComponent(text)
      );
      pom.setAttribute("download", filename);

      if (document.createEvent) {
        var event = document.createEvent("MouseEvents");
        event.initEvent("click", true, true);
        pom.dispatchEvent(event);
      } else {
        pom.click();
      }
    },
  },
};
</script>
